import React from "react";
import { Box, Button, Container, Divider, Stack, Typography } from "@mui/material";
import SupportAgentRoundedIcon from "@mui/icons-material/SupportAgentRounded";
import { useLocation, useNavigate } from "react-router-dom";
import logo from "../images/LogoNavbar1.svg";
import PublicContactDialog from "./PublicContactDialog";
import { PublicHomeFooter } from "./home/PublicEntryUI";

// WP-STANDARD | PUBLIC FOOTER CONTACT ENTRY
// STATUS: STATIC_PASS · RUNTIME_PENDING
// Footer no longer leaks directly to one channel: every public page now offers
// WhatsApp or an embedded implementation call from the same reusable chooser.
export default function Footer() {
  const navigate = useNavigate();
  const location = useLocation();
  const [contactOpen, setContactOpen] = React.useState(false);

  if (location.pathname === "/") {
    return (
      <>
        <PublicHomeFooter onContact={() => setContactOpen(true)} />
        <PublicContactDialog open={contactOpen} onClose={() => setContactOpen(false)} mode="support" sourceLabel="Footer público" />
      </>
    );
  }

  return (
    <>
      <Box component="footer" sx={{ bgcolor: "#19242F", color: "#fff", pt: { xs: 4, sm: 6, md: 8 }, pb: { xs: 2.5, md: 3 } }}>
        <Container maxWidth="lg">
          <Box sx={{ maxWidth: 520 }}>
            <Stack direction="row" alignItems="center" spacing={1.2}>
              <Box component="img" src={logo} alt="WebProfit" sx={{ width: { xs: 40, sm: 46 }, height: { xs: 40, sm: 46 } }} />
              <Typography sx={{ fontWeight: 950, fontSize: "1.55rem", letterSpacing: "-.035em" }}>WebProfit</Typography>
            </Stack>
            <Typography sx={{ mt: 1, color: "rgba(255,255,255,.6)", lineHeight: 1.5, fontSize: { xs: ".88rem", sm: "1rem" } }}>
              Curso rápido, recursos y soporte de WebProfit.
            </Typography>
          </Box>

          <Divider sx={{ my: { xs: 2.5, sm: 4 }, borderColor: "rgba(255,255,255,.1)" }} />

          <Stack direction={{ xs: "column", md: "row" }} justifyContent="space-between" alignItems={{ xs: "flex-start", md: "center" }} spacing={3}>
            <Stack direction="row" useFlexGap flexWrap="wrap" spacing={{ xs: .35, sm: 2.5 }}>
              <Button onClick={() => navigate("/")} sx={{ color: "rgba(255,255,255,.72)", textTransform: "none", fontWeight: 750, justifyContent: "flex-start", minHeight: { xs: 34, sm: 36 }, px: { xs: .8, sm: 1 } }}>Inicio</Button>
              {/* WP-STANDARD | PUBLIC FOOTER NAVIGATION
                  STATUS: STATIC_PASS · RUNTIME_PENDING
                  Only stable destinations stay public; pricing/modules return when
                  their dedicated experiences are production-ready. */}
              <Button onClick={() => navigate("/curso")} sx={{ color: "rgba(255,255,255,.72)", textTransform: "none", fontWeight: 750, justifyContent: "flex-start", minHeight: { xs: 34, sm: 36 }, px: { xs: .8, sm: 1 } }}>Curso</Button>
              <Button onClick={() => setContactOpen(true)} startIcon={<SupportAgentRoundedIcon />} sx={{ color: "rgba(255,255,255,.72)", textTransform: "none", fontWeight: 750, justifyContent: "flex-start", minHeight: { xs: 34, sm: 36 }, px: { xs: .8, sm: 1 } }}>Contacto y soporte</Button>
            </Stack>
            <Typography sx={{ color: "rgba(255,255,255,.42)", fontSize: ".82rem" }}>
              © {new Date().getFullYear()} WebProfit. Todos los derechos reservados.
            </Typography>
          </Stack>
        </Container>
      </Box>

      <PublicContactDialog open={contactOpen} onClose={() => setContactOpen(false)} mode="support" sourceLabel="Footer público" />
    </>
  );
}
